<h4 >Reagendamento</h4>
<div class="separator"></div>
<h5 *ngIf="(profile !== 'Master' && profile !== 'Master Cliente' && typeSurvey === 'TRADICIONAL')">
    Ao confirmar o reagendamento, a vistoria será distribuída para outro prestador.
</h5>
<h5 *ngIf="(profile !== 'Master' && profile !== 'Master Cliente' && typeSurvey === 'VISTORIA ACOMPANHADA')">
  Ao confirmar o reagendamento, será alterada a modalidade da vistoria de VISTORIA ACOMPANHADA para TRADICIONAL e será distribuída para outro prestador.
</h5>
<h5 *ngIf="profile === 'Master' || profile === 'Master Cliente' || typeSurvey === 'MOBILE'">
  Ao confirmar o reagendamento, será alterada a modalidade da vistoria para a opção selecionada e será distribuída para outro prestador.
</h5>
<div class="container-table">
    <ul class="list-survey-type" *ngIf="typeSurvey === 'MOBILE'">
      <li>
        <input type="radio" name="surveyType" value="4" (change)="selectSurveyType($event)"> Vistoria Acompanhada
      </li>
      <li>
        <input type="radio" name="surveyType" value="3" (change)="selectSurveyType($event)"> Tradicional
      </li>
    </ul>

    <ul class="list-survey-type" *ngIf="profile === 'Master'  && typeSurvey === 'VISTORIA ACOMPANHADA'">
      <li>
        <input type="radio" name="surveyType" value="1" (change)="selectSurveyType($event)"> Mobile
      </li>
      <li>
        <input type="radio" name="surveyType" value="3" (change)="selectSurveyType($event)"> Tradicional
      </li>
    </ul>

    <ul class="list-survey-type" *ngIf="profile === 'Master Cliente'  && typeSurvey === 'VISTORIA ACOMPANHADA'">
      <li>
        <input type="radio" name="surveyType" value="1" (change)="selectSurveyType($event)"> Mobile
      </li>
      <li>
        <input type="radio" name="surveyType" value="3" (change)="selectSurveyType($event)"> Tradicional
      </li>
    </ul>

    <ul class="list-survey-type" *ngIf="profile === 'Master' && typeSurvey === 'TRADICIONAL'">
      <li>
        <input type="radio" name="surveyType" value="4" (change)="selectSurveyType($event)"> Vistoria Acompanhada
      </li>
      <li>
        <input type="radio" name="surveyType" value="1" (change)="selectSurveyType($event)"> Mobile
      </li>
    </ul>

    <ul class="list-survey-type" *ngIf="profile === 'Master Cliente' && typeSurvey === 'TRADICIONAL'">
      <li>
        <input type="radio" name="surveyType" value="4" (change)="selectSurveyType($event)"> Vistoria Acompanhada
      </li>
      <li>
        <input type="radio" name="surveyType" value="1" (change)="selectSurveyType($event)"> Mobile
      </li>
    </ul>

    <p style="margin-top: 10px;" *ngIf="rescheduleCount == 1 && profile !== 'Master' && profile !== 'Master Cliente'"><b>É permitido somente 2 agendamentos por vistoria.</b></p>
    <app-input-select *ngIf="data.cancelReasons?.length > 0" name="cancelReason" [formGroup]="form" [className]="'error'"
        controlName="cancelReasons" title="motivos" [classInfo]="hasErrorReason ? 'error' :''"
        [values]="data.cancelReasons">
    </app-input-select>
    <div style="margin-top: 4%;">
        <button (click)="cancel()" type="button" class="remove-button cancel-remove mr-4" value="nao">Não</button>
        <button (click)="submit()" [disabled]="!enableButton" type="button" class="send-button cancel-send" value="sim">Sim</button>
    </div>

</div>
